import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { IOrderReturn } from "../../types/orderReturn.type";
import useGetRequest from "../../hooks/useGetRequest";
import { Button, Form, Input, InputNumber, message, Modal, Table } from "antd";
import Title from "antd/es/typography/Title";
import { api } from "../../api/api";

export default function OrderReturns() {
  const { id, name, receipt } = useParams();
  const [returns, setReturns] = useState<IOrderReturn[]>([]);
  const { data, loading, refresh } = useGetRequest(`/order/sale-returns/${id}`);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (data) {
      setReturns(data);
    }
  }, [data]);

  const handleCreateReturn = async (values: {
    quantity: number;
    returnReason: string;
    kg: number;
  }) => {
    setConfirmLoading(true);

    try {
      await api.post(`/order/sale-returns/${id}`, values);
      message.success("Возврат успешно добавлен.");
    } catch (error: any) {
      console.error("Ошибка добавления возврата.", error);
      message.error(error.response.data.error);
    } finally {
      setConfirmLoading(false);
      setIsModalOpen(false);
      refresh();
    }
  };

  const columns = [
    {
      title: "Дата",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Клиент",
      dataIndex: "clientId",
      key: "clientId",
      render: (data: any) => data.name,
    },
    {
      title: "Продукт",
      dataIndex: "produceId",
      key: "produceId",
      render: (data: any) => data.name,
    },
    {
      title: "Количество",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "Кг",
      dataIndex: "kg",
      key: "kg",
    },
    {
      title: "Причина возврата",
      dataIndex: "returnReason",
      key: "returnReason",
    },
    {
      title: "Пользователь",
      dataIndex: "ownerId",
      key: "ownerId",
      render: (data: any) => data.username,
    },
    {
      title: "Цена",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "Общая стоимость",
      dataIndex: "total",
      key: "total",
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Title level={2}>Возвраты {name} {receipt}</Title>
        <Button type="primary" onClick={() => setIsModalOpen(true)}>
          Добавить
        </Button>
      </div>

      <Table
        loading={loading}
        columns={columns}
        dataSource={returns}
        rowKey={(record) => record._id}
        scroll={{ x: "max-content" }}
      />

      <Modal
        title="Добавить возврат"
        open={isModalOpen}
        confirmLoading={confirmLoading}
        onCancel={() => setIsModalOpen(false)}
        onOk={() => form.submit()}
      >
        <Form form={form} layout="vertical" onFinish={handleCreateReturn}>
          <Form.Item
            name="quantity"
            label="Количество"
            rules={[{ required: true, message: "Пожалуйста, введите кол-во" }]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            name="kg"
            label="Кг"
            rules={[{ required: true, message: "Пожалуйста, введите кг" }]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            name="returnReason"
            label="Причина возврата"
            rules={[
              {
                required: true,
                message: "Пожалуйста, введите причину возврата",
              },
            ]}
          >
            <Input.TextArea rows={4} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
